import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function AdminRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-brand-bg text-brand-muted">
        Ładowanie…
      </div>
    );
  }
  if (!user) return <Navigate to="/logowanie" replace />;
  if (user.role !== "admin") return <Navigate to="/biblioteka" replace />;
  return children;
}
